import api from './api';

export type FeatureFlagsMap = Record<string, boolean>;

export const featureFlagApi = {
  getFlags: async (): Promise<FeatureFlagsMap> => {
    const res = await api.get<{ success: boolean; flags: FeatureFlagsMap }>('/feature-flags');
    return res.data.flags;
  },
};
